import React from 'react';
import { Box, Typography } from '@mui/material';

const PairingCanva = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      gap: 1,
      p: 4,
    }}
  >
    <Typography variant="h5" sx={{ color: '#313031', fontWeight: 600 }}>
      Connect VCPlayer to Canva
    </Typography>
    <Typography variant="body2" color="text.secondary">
      Start the connection from the VCPlayer app in Canva. Select Connect to
      VCPlayer to securely sign in and approve access.
    </Typography>
  </Box>
);

export default PairingCanva;